(function () {
    'use strict';

    angular
        .module('app.login')
        .component('sc3EmailConfirmationModal', {
            templateUrl: 'app/login/email-confirmation-modal.component.html',
            bindings: { close: '&', dismiss: '&', resolve: '<' },
            controller: EmailConfirmationModalComponent
        });

    var extend = angular.extend;

    EmailConfirmationModalComponent.$inject = ['Member', 'alert', 'login_resources', 'user'];
    function EmailConfirmationModalComponent(Member, alert, resources, user) {
        var ctrl = this;
        ctrl.submit = submit;

        //////////////////////
        function submit() {
            var data = ctrl.resolve.data;
            if (ctrl.form.$valid) {
                Member.saveEmail({ id: data.individualId }, data, success, error, true);

                function success(data) {
                    user.email = data.email;
                    ctrl.close();
                }
                function error() {
                    alert.error(resources.saveEmailFailed);
                }
            }
        }
    }
})();